/** import custom dependency [start] */
import { getData } from '../';
import URL from '../../utils/baseUrls';
/** import custom dependency [end] */

/**
 * Get the region data form the backend
 * @param cloudId Cloud identifier
 * @returns
 */
export const getCloudRegionData = async (cloudId: string | number) => {
    const res = await getData(URL.getCloudRegion(cloudId));
    return res;
};

/**
 * Get the Cloud list form the backend
 * @returns
 */
export const getCloudList = async () => {
    const res = await getData(URL.getCloudListUrl());
    return res;
};

/**
 * Get the Cloud cred list form the backend
 * @param cloudId
 * @returns
 */
export const getCloudCredList = async (cloudId: string) => {
    const res = await getData(URL.getCloudCredUrl(cloudId));
    return res;
};


/**
 * Get the Instance list from the backend
 * @param cloudId Cloud ID
 * @returns 
 */
export const getInstanceTypes = async (cloudId: string) => {
    const res = await getData(URL.getInstanceTypesUrl(cloudId));
    return res;
};
